import React, {useEffect, useState, useCallback} from 'react';
import {withRouter, useParams, Link} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {Menu} from '../../utils/menu/Menu';
import {
  triggerActiveAction,
  triggerEditAction,
  triggerGetAction,
} from '../../actions/triggersAction';
import {formatErrors, UPDATE_USERS, userPrintName} from '../../constants';
import {toast} from 'react-toastify';
import {InputProfile} from "../../utils/input/InputProfile";
import { Flow } from '../../utils/flow/Flow';
import { ReactFlowProvider } from '@xyflow/react';
import {curatorsAction} from "../../actions/usersAction";

function Trigger(props) {
  const user = useSelector(state => state.user.profile);
  const dispatch = useDispatch();
  const {id} = useParams();
  const [item, setItem] = useState(null);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    id: 0,
    name: '',
    active: false,
    blocks: {
      nodes: [],
      edges: []
    }
  });
  const [loading, setLoading] = useState(false);
  const {history} = props;
  
  const getTrigger = useCallback((id) => {
    dispatch(triggerGetAction(id)).then((data) => {
      setItem({id: data.id, name: data.name});
      const blocks = data.blocks ? JSON.parse(data.blocks) : {nodes: [], edges: []};
      blocks.nodes.forEach(node => {
        if (node.data) {
          node.data.disabled = data.active;
        }
      });
      setForm({
        id: data.id,
        name: data.name,
        active: data.active,
        blocks: {
          nodes: blocks.nodes,
          edges: blocks.edges
        }
      });
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);
  
  const handleChangeForm = (e) => {
    const {name, value} = e.target;
    setForm(prev => ({...prev, [name]: value}));
    setErrors(prev => ({...prev, [name]: value.trim() === ''}));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;

    const errs = {};
    if (!form.name) errs.name = true;

    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    setLoading(true);
    saveData(form);
  };

  const saveData = (form) => {
    dispatch(triggerEditAction({...form, blocks: JSON.stringify(form.blocks)})).then((data) => {
      setLoading(false);
      toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
      if (!form.id) {
        history.push('/trigger/' + data.id);
      }
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }

  const saveFlow = (nodes, edges) => {
    saveData({...form, blocks: {nodes, edges}});
  }

  const changeActive = () => {
    if (loading) return;
    setLoading(true);
    dispatch(triggerActiveAction(form.id)).then(() => {
      setLoading(false);
      const active = !form.active;
      form.blocks.nodes.forEach(node => {
        if (node.data) {
          node.data.disabled = active;
        }
      });
      setForm({...form, active, blocks: {nodes: form.blocks.nodes, edges: form.blocks.edges}});
      toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }
    
  useEffect(() => {
    if (id && id !== '0') {
      getTrigger(id);
    }
  }, [id, getTrigger]);

  // get curators list
  const getCuratorsList = useCallback(() => {
    dispatch(curatorsAction()).then((data) => {
      let list = [{ key: '', text: 'Все', value: '' }];
      (data || []).forEach((i) => {
          let name = userPrintName(i);
          list.push({key: i.id, text: name, value: i.id, role_id: i.role_id, status: i.status});
      });
      dispatch({type: UPDATE_USERS, list});
    }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  useEffect(() => {
    if (!user || !user.id) {
        return;
    }
    getCuratorsList();
  }, [user, getCuratorsList]);

  return <div className="content">
    <Menu />

    <header className="header header--nav">
      <Link to={'/triggers'} className="header__link">Процессы</Link>
    </header>
  
    <div className="profile">
      {!form.id && <form className="profile__wrapper" noValidate onSubmit={handleSubmit}>
        <div className="profile__inner profile__inner--group">
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Название"
                          name="name"
                          placeholder="Введите название"
                          value={form.name}
                          error={errors.name || "false"}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
        </div>
        <div>
        </div>
        <button className="profile__btn btn">Сохранить</button>
      </form>}

      {form.id && <div className='profile__wrapper'>
        {item && <h4 className="profile__heading">Процесс: <input type="text" style={{width: '250px'}}
                          name="name"
                          className="input"
                          placeholder="Введите название"
                          value={form.name}
                          error={errors.name || "false"}
                          disabled={loading}
                          onChange={handleChangeForm}/></h4>}
        <div style={{textAlign: "left"}}>
          <ReactFlowProvider>
            <Flow  nodesInit={form.blocks.nodes || []} edgesInit={form.blocks.edges || []} active={form.active} onSave={saveFlow} 
              onActiveChange={form.id ? changeActive : null} flowId={form.id} />
          </ReactFlowProvider>
        </div>
      </div>}
    </div>
  </div>;
};

export default withRouter(Trigger);
